import { permissionKey } from '../../feature/permissions/models/Permission';

export type OperationId = 'view' | 'create' | 'edit' | 'delete';

export const can = (moduleId: string, operationId: OperationId): string => permissionKey(moduleId, operationId);
